// extracted by mini-css-extract-plugin
export default {"subtitle":"reviews_subtitle__QfsYS","reviewContainer":"reviews_reviewContainer__hvfth"};